var amdi18n={"__root":{"privacy_policy_skidentity":"Privacy policy for SkIDentity Identity Management","approval_checkbox":"I agree","create_cloud_identity":"Create Cloud Identity","revoke_cloud_identities":"Revoke Cloud Identities"},"__de":{"privacy_policy_skidentity":"Datenschutzerklärung für SkIDentity Identitätsmanagement","approval_checkbox":"Ich bin einverstanden","create_cloud_identity":"Cloud Identität erzeugen","revoke_cloud_identities":"Cloud Identitäten sperren"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/PrivacyPolicyState_strings.js
// module id = 67
// module chunks = 3